import { SimpleTradeCompanyListItem } from 'api';
import { TradeCompanyAutocomplete, useFormContext } from 'form';
import { useTranslation } from 'i18n';
import { useContext } from 'react';
import { SectionContainer } from 'ui';

import { SalesOrderFormContext } from '../../contexts/SalesOrderFormContext';

export const BuyerPartiesSection = () => {
  const { t } = useTranslation('orders');
  const { setValue } = useFormContext();
  const { defaultValues, variant } = useContext(SalesOrderFormContext);
  const onPurchaseChange = (tradeCompany: SimpleTradeCompanyListItem) => {
    if (tradeCompany.currency) {
      setValue('buyer_currency', tradeCompany.currency);
      setValue('third_party_commission_currency', tradeCompany.currency);
    }
  };

  return (
    <SectionContainer title={t('buyerPartiesSection.title')}>
      <TradeCompanyAutocomplete
        name="purchaser_id"
        label={t('buyerPartiesSection.purchaserLabel')}
        onlyBuyers={true}
        excludeKycBanned
        required
        onSelectOption={onPurchaseChange}
        defaultValue={defaultValues?.purchaser_id}
        infoTooltip={t('buyerPartiesSection.purchaserTooltip')}
      />
      <TradeCompanyAutocomplete
        name="buyer_agent_id"
        label={t('buyerPartiesSection.buyerAgentLabel')}
        defaultValue={defaultValues?.buyer_agent_id ?? undefined}
        onlyBuyers={true}
        excludeKycBanned
        infoTooltip={t('buyerPartiesSection.buyerAgentTooltip')}
      />
      <TradeCompanyAutocomplete
        name="end_processor_id"
        label={t('buyerPartiesSection.endProcessorLabel')}
        onlyBuyers={true}
        excludeKycBanned
        required
        defaultValue={defaultValues?.end_processor_id}
        infoTooltip={t('buyerPartiesSection.endProcessorTooltip')}
      />
      {variant === 'update' ? (
        <TradeCompanyAutocomplete
          name="consignee_id"
          label={t('buyerPartiesSection.consigneeLabel')}
          onlyBuyers={true}
          excludeKycBanned
          required
          defaultValue={defaultValues?.consignee_id}
        />
      ) : null}
    </SectionContainer>
  );
};
